import axios from 'axios';

export function describeRequestError(error: unknown): string {
	if (axios.isAxiosError(error)) return `code=${error.code ?? '-'} status=${error.response?.status ?? '-'} message=${error.message}`;
	if (error instanceof Error) return `message=${error.message}`;
	return `message=${String(error)}`;
}
